import { PostalResponse } from '@dav-model/api/response/postal.response.model';
import { CartItem } from '@dav-model/cart/cart-item.model';
import { CartTaxFormValues } from '@dav-model/cart/cart-tax-form-values.model';
import { LoadQuote } from '@dav-model/cart/load-quote.model';
import { ValidatedCart } from '@dav-model/cart/validate-cart.model';
import { CheckoutFormValues } from '@dav-model/checkout/checkout-form-values.model';
import { SubmittedCartItem } from '@dav-model/checkout/submit_cart/response/submitted-cart-item.model';
import { Forms } from '@dav-model/form/form';
import { Action } from '@ngrx/store';

/**
 * When User adds to the cart from the product page
 * call Validations to validate the cart.
 */
export const ADD_CART = '[Cart] ADD CART';
export const DELETE_CART = '[Cart] DELETE CART';
export const ADD_TAXES = '[Cart] ADD_TAXES';
export const ADD_TAXES_SUCCESS = '[Cart] ADD_TAXES_SUCCESS';
export const GET_CUSTOMER_POSTAL = '[Cart] GET CUSTOMER POSTAL';
export const GET_CUSTOMER_POSTAL_SUCCESS = '[Cart] GET CUSTOMER POSTAL SUCCESS';
export const GET_COSIGNER_POSTAL = '[Cart] GET COSIGNER POSTAL';
export const GET_COSIGNER_POSTAL_SUCCESS = '[Cart] GET COSIGNER POSTAL SUCCESS';
export const TOGGLE_COSIGNER_FORM = '[Checkout] TOGGLE COSIGNER FORM';
export const GET_CHECKOUT_FORM = '[Cart] GET CHECKOUT FORM';
export const GET_CHECKOUT_FORM_SUCCESS = '[Cart] GET CHECKOUT FORM SUCCESS';
export const UPDATE_CHECKOUT_FORM = '[Cart] UPDATE CHECKOUT FORM';
export const UPDATE_CUSTOMER_COST = '[Cart] UPDATE CUSTOMER COST';
export const UPDATE_TAX_FORM_VALUES = '[Cart] UPDATE TAX FORM VALUES';
export const UPDATE_LIENHOLDER_WITH_NEWLY_ADDED = '[Cart] UPDATE LIENHOLDER WITH NEWLY ADDED';
export const SUBMIT_CART = '[Cart] SUBMIT CART';
export const RESET_CART = '[Cart] RESET CART';
export const SUBMIT_CART_SUCCESS = '[Cart] SUBMIT_CART SUCCESS';
export const VALIDATE_CART_SUCCESS = '[Cart] VALIDATE_CART SUCCESS';
export const CART_FAILURE = '[Cart] VALIDATE FAILURE';
export const CART_UMU_FAILURE = '[Cart] CART_UMU_FAILURE';
export const SAVE_AS_QUOTE = '[Cart] SAVE AS QUOTE';
export const SAVE_AS_QUOTE_SUCCESS = '[Cart] SAVE AS QUOTE SUCCESS';
export const SAVE_AS_QUOTE_FAILURE = '[Cart] SAVE AS QUOTE FAILURE';
export const SAVE_AS_UMU_QUOTE = '[Cart] SAVE AS UMU QUOTE';
export const SAVE_AS_UMU_QUOTE_SUCCESS = '[Cart] SAVE AS UMU QUOTE SUCCESS';
export const SAVE_AS_UMU_QUOTE_FAILURE = '[Cart] SAVE AS UMU QUOTE FAILURE';
export const SAVE_AS_UMU_CREDIT = '[Cart] SAVE AS UMU CREDIT';
export const SAVE_AS_UMU_CREDIT_SUCCESS = '[Cart] SAVE AS UMU CREDIT SUCCESS';
export const SAVE_AS_UMU_CREDIT_FAILURE = '[Cart] SAVE AS UMU CREDIT FAILURE';
export const LOAD_QUOTE = '[Cart] LOAD QUOTE';
export const LOAD_QUOTE_SUCCESS = '[Cart] LOAD QUOTE SUCCESS';
export const SET_CREDIT_FORM_ENABLE = '[Cart] SET CREDIT FORM ENABLE';
export const RESET_INRESPONSE = '[Cart] RESET_INRESPONSE';


export class AddCartAction implements Action {
  readonly type = ADD_CART;

  constructor(public cartItem: CartItem) {
  }
}


export class SetCreditFromAction implements Action {
  readonly type = SET_CREDIT_FORM_ENABLE;

  constructor(public creditFormEnable: boolean) {
  }
}


export class AddTaxesAction implements Action {
  readonly type = ADD_TAXES;
}

export class AddTaxesSuccessAction implements Action {
  readonly type = ADD_TAXES_SUCCESS;

  constructor(public payload: any) {
  }
}

export class DeleteCartAction implements Action {
  readonly type = DELETE_CART;

  constructor(public cartItemSelector: { key: string }) {
  }
}

export class SubmitCartAction implements Action {
  readonly type = SUBMIT_CART;

  constructor(public payload: any) {
  }
}


export class AddAndValidateCartSuccessAction implements Action {
  readonly type = VALIDATE_CART_SUCCESS;

  constructor(public payload: { validatedCart: ValidatedCart }) {
  }
}

export class GetCustomerPostalAction implements Action {
  readonly type = GET_CUSTOMER_POSTAL;

  constructor(public payload: string) {
  }
}

export class GetCustomerPostalSuccessAction implements Action {
  readonly type = GET_CUSTOMER_POSTAL_SUCCESS;

  constructor(public payload: PostalResponse) {
  }
}

export class GetCosignerPostalAction implements Action {
  readonly type = GET_COSIGNER_POSTAL;

  constructor(public payload: string) {
  }
}

export class GetCosignerPostalSuccessAction implements Action {
  readonly type = GET_COSIGNER_POSTAL_SUCCESS;

  constructor(public payload: PostalResponse) {
  }
}

export class ToggleCosignerFormAction implements Action {
  readonly type = TOGGLE_COSIGNER_FORM;

  constructor(public payload: boolean) {
  }
}

export class GetCheckouFormAction implements Action {
  readonly type = GET_CHECKOUT_FORM;
}

export class GetCheckouFormSuccessAction implements Action {
  readonly type = GET_CHECKOUT_FORM_SUCCESS;

  constructor(public payload: Forms) {
  }
}

export class UpdateCheckoutFormAction implements Action {
  readonly type = UPDATE_CHECKOUT_FORM;

  constructor(public payload: CheckoutFormValues) {
  }
}

export class UpdateLienholderWithNewlyAddedAction implements Action {
  readonly type = UPDATE_LIENHOLDER_WITH_NEWLY_ADDED;

  constructor(public payload: {}) {
  }
}


export class UpdateTaxFormValuesAction implements Action {
  readonly type = UPDATE_TAX_FORM_VALUES;

  constructor(public payload: CartTaxFormValues[]) {
  }
}

export class UpdateCustomerCostAction implements Action {
  readonly type = UPDATE_CUSTOMER_COST;

  constructor(public payload: { customerCost: number, cartItemKey: string }) {
  }
}

export class SubmitCartSuccessAction implements Action {
  readonly type = SUBMIT_CART_SUCCESS;

  constructor(public payload: { invalidCart: CartItem[], submittedCart: SubmittedCartItem[] }) {
  }
}


export class SaveAsQuoteAction implements Action {
  readonly type = SAVE_AS_QUOTE;
}

export class SaveAsUMUQuoteAction implements Action {
  readonly type = SAVE_AS_UMU_QUOTE;

  constructor(public payload: any) {
  }
}

export class SaveAsUMUQuoteSuccessAction implements Action {
  readonly type = SAVE_AS_UMU_QUOTE_SUCCESS;

  constructor(public payload: any) {
  }
}

export class SaveAsUMUQuoteFailureAction implements Action {
  readonly type = SAVE_AS_UMU_QUOTE_FAILURE;

  constructor(public payload: any) {
  }
}

export class SaveAsUMUCreditAction implements Action {
  readonly type = SAVE_AS_UMU_CREDIT;

  constructor(public payload: any) {
  }
}

export class SaveAsUMUCreditSuccessAction implements Action {
  readonly type = SAVE_AS_UMU_CREDIT_SUCCESS;

  constructor(public payload: any) {
  }
}

export class SaveAsUMUCreditFailureAction implements Action {
  readonly type = SAVE_AS_UMU_CREDIT_FAILURE;

  constructor(public payload: any) {
  }
}

export class LoadQuoteAction implements Action {
  readonly type = LOAD_QUOTE;
}

export class LoadQuoteSuccessAction implements Action {
  readonly type = LOAD_QUOTE_SUCCESS;

  constructor(public payload: LoadQuote) {
  }
}


export class CartFailureAction implements Action {
  readonly type = CART_FAILURE;

  constructor(public payload: any) {
  }
}

export class CartUMUFailureAction implements Action {
  readonly type = CART_UMU_FAILURE;

  constructor(public payload: any) {
  }
}

export class ResetCartAction implements Action {
  readonly type = RESET_CART;
}

export class ResetInresponseAction implements Action {
  readonly type = RESET_INRESPONSE;
}

export type All =
  AddCartAction
  | SubmitCartAction
  | DeleteCartAction
  | SubmitCartSuccessAction
  | AddAndValidateCartSuccessAction
  | CartFailureAction
  | GetCheckouFormSuccessAction
  | ResetCartAction
  | LoadQuoteSuccessAction
  | GetCosignerPostalSuccessAction
  | GetCustomerPostalSuccessAction
  | UpdateCheckoutFormAction
  | ToggleCosignerFormAction
  | UpdateLienholderWithNewlyAddedAction
  | UpdateTaxFormValuesAction
  | UpdateCustomerCostAction
  | AddTaxesAction
  | AddTaxesSuccessAction
  | SetCreditFromAction
  | SaveAsUMUCreditSuccessAction
  | SaveAsUMUCreditFailureAction
  | CartUMUFailureAction
  | SaveAsUMUQuoteAction
  | SaveAsUMUQuoteSuccessAction
  | SaveAsUMUQuoteFailureAction
  | ResetInresponseAction;
